import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../../main/main.styles';
import REsuretyLogo from '../../../../../assets/REsurety-logo.svg';
import { mixinRobotoBold, mixinRobotoRegular } from '../../../../../styles';

export const ProjectMetricsStyles = css`
  ${MainStyles}

  :host {
    display: contents;
  }

  .quantiles-card {
    padding: 16px 6px 40px;
    height: 100%;
    position: relative;
    min-width: 320px;
  }

  .quantiles-card .header-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .quantiles-card .header-wrapper .right-side {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .quantiles-card .header-wrapper zero-icon {
    cursor: pointer;
  }

  .quantiles-card .header-wrapper .header {
    font-size: 18px;
    color: var(--white);
    ${mixinRobotoBold}
  }

  .header-wrapper .right-side zero-segmented-control {
    margin: 0;
  }

  .header-wrapper .right-side zero-segmented-item {
    padding: 5px;
  }

  .section {
    display: flex;
    flex-direction: column;
  }

  .section .section-header {
    font-size: 16px;
    padding: 5px 0 0;
    color: var(--primary-color);
  }

  .tile {
    width: 100%;
    position: relative;
    margin-top: 5px;
    padding: 13px 16px;
    background: var(--card-header-bg);
    border: 1px solid var(--border-1);
  }

  .tile-header {
    padding-top: 6px;
    font-size: 12px;
    color: #bcbcbe;
  }

  .tile .tile-content {
    font-size: 18px;
    color: var(--white);
  }

  .footer {
    position: absolute;
    display: flex;
    gap: 5px;
    bottom: 10px;
    right: 0;
    font-size: 11px;
    ${mixinRobotoRegular}
  }

  .disclaimer-div {
    padding-top: 20px;
  }

  .disclaimer {
      font-size: 12px;
      color: var(--error);
      ${mixinRobotoRegular}
  }

  .resurety-logo {
    background: url(${REsuretyLogo}) no-repeat;
    background-size: contain;
    width: 75px;
    height: 20px;
    display: inline-block;
  }
`;
